import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_HANDLING_COST, propTypes } from '../../util/types';
import { shippingLineOf } from './LineItemShippingFeeMaybe';

import css from './OrderBreakdown.module.css';

const LineItemHandlingCostMaybe = props => {
  const { lineItems, intl, isCustomer } = props;

  // Buyer view absorbs handling into the shipping line (see LineItemShippingFeeMaybe):
  // without one, it is its own line, as it is charged.
  // Provider/admin view keeps it as its own line for accounting clarity.
  if (isCustomer && shippingLineOf(lineItems)) return null;

  const handlingCostLineItem = lineItems.find(
    item => item.code === LINE_ITEM_HANDLING_COST && !item.reversal
  );

  return handlingCostLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.handlingCost" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, handlingCostLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

LineItemHandlingCostMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemHandlingCostMaybe;
